import React from 'react';
import { StyledControlButton } from './style';

export const ControlButton: React.FC = ({ children, ...props }) => {
  return <StyledControlButton {...props}>{children}</StyledControlButton>;
};
